import { registerPlugin } from '@capacitor/core';

type OpenOptions = {
  url: string;
};

type NativeAuthLauncherPlugin = {
  open(options: OpenOptions): Promise<void>;
};

export const NativeAuthLauncher = registerPlugin<NativeAuthLauncherPlugin>('NativeAuthLauncher');
